export default {
  shared: {
    api: {
      unknownError: 'Неизвестная ошибка',
    },
  },
};
